import { render } from "./Query.vue?vue&type=template&id=0b3cf0f5&scoped=true"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"

import "./Query.vue?vue&type=style&index=0&id=0b3cf0f5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3cf0f5"]])

export default __exports__